import { render, staticRenderFns } from "./IcoLanguageThai.vue?vue&type=template&id=83bc2074"
import script from "./IcoLanguageThai.vue?vue&type=script&lang=js"
export * from "./IcoLanguageThai.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports